import React, { useMemo } from 'react';
import { Calendar } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { ESTADO_COLORS, formatHora } from './agendaConstants';
import './agendaCalendario.css';

dayjs.locale('es');

const AgendaCalendarioMensual = ({
  reuniones,
  currentDate,
  onDateChange,
  onModoChange,
  onSelectReunion,
  onSelectDay,
}) => {
  const byDate = useMemo(() => {
    const map = {};
    reuniones.forEach((r) => {
      const key = String(r.fecha).slice(0, 10);
      if (!map[key]) map[key] = [];
      map[key].push(r);
    });
    return map;
  }, [reuniones]);

  const byMonth = useMemo(() => {
    const map = {};
    reuniones.forEach((r) => {
      const key = String(r.fecha).slice(0, 7);
      map[key] = (map[key] || 0) + 1;
    });
    return map;
  }, [reuniones]);

  const cellRender = (date, info) => {
    if (info.type === 'month') {
      const key = date.format('YYYY-MM');
      const count = byMonth[key] || 0;
      if (!count) return null;

      const texto =
        count === 1 ? 'En este mes hay 1 reunión' : `En este mes hay ${count} reuniones`;

      return <div className="agenda-mes-resumen">{texto}</div>;
    }

    const key = date.format('YYYY-MM-DD');
    const items = byDate[key] || [];
    if (!items.length) return null;

    return (
      <ul className="agenda-reuniones-dia" onMouseDown={(e) => e.stopPropagation()}>
        {items.map((r) => (
          <li key={r.id}>
            <span
              role="button"
              tabIndex={0}
              className="agenda-reunion-chip"
              style={{ background: ESTADO_COLORS[r.estado] || '#1677ff' }}
              onClick={(e) => {
                e.stopPropagation();
                onSelectReunion(r);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSelectReunion(r);
              }}
              title={`${r.cliente} — ${formatHora(r.horaInicio)}`}
            >
              {formatHora(r.horaInicio)} {r.cliente}
            </span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="agenda-calendario">
      <Calendar
        fullscreen
        value={currentDate}
        onPanelChange={(date, mode) => {
          onDateChange(date);
          onModoChange?.(mode);
        }}
        onSelect={(date, { source }) => {
          if (source === 'date') {
            onSelectDay(date.format('YYYY-MM-DD'));
          }
        }}
        cellRender={cellRender}
      />
    </div>
  );
};

export default AgendaCalendarioMensual;
